import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export function initSlider(): void {
  const sliderEl = document.querySelector<HTMLElement>(".js-slider");
  if (!sliderEl) return;

  new Swiper(sliderEl, {
    modules: [Autoplay],
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 16,
    speed: 12000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    allowTouchMove: false,
  });
}
